import { setSelectedOrganization, useAppDispatch, useGetSelectedOrganization } from '@/redux';

export function useSelectedOrganization() {
  const dispatch = useAppDispatch();
  const selectedOrganization = useGetSelectedOrganization();

  const setSelectedOrganizationName = (organizationName: string) => {
    dispatch(setSelectedOrganization(organizationName));
  };

  return {
    selectedOrganization: selectedOrganization ?? '',
    setSelectedOrganization: setSelectedOrganizationName,
  };
}
